<template>
    <el-dialog
        :visible.sync="dialogVisiable"
        :close-on-click-modal="false"
        custom-class="position-center"
        top="0"
        width="740px"
        @close="handleDialogClose"
    >
        <div class="form-title">批量导入设备</div>

        <div class="dialog-import">
            <el-steps :active="stepsActive" finish-status="success">
              <el-step title="上传文档"></el-step>
              <el-step title="导入数据"></el-step>
              <el-step title="完成"></el-step>
            </el-steps>

            <div class="import-box import-step1" v-show="stepsActive === 0">
                <div class="download-txt">
                    <span>一、请按照数据模版的格式准备要导入的数据</span>
                    <a href="http://apart3.geelocks.com/file/template/GateMagnetism/设备批量导入模版.xls" target="_blank">下载数据模版</a>
                </div>

                <div class="form">
                    <!-- <div class="form-body">
                        <el-form label-width="75px">
                            <el-form-item label="设备类型：">
                                <el-select v-model="device_type" placeholder="请选择设备类型">
                                    <el-option label="门磁" :value="0"></el-option>
                                    <el-option label="迷你报警器" :value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div> -->
                    <div class="form-footer">
                        <el-upload
                            class="upload-botton"
                            :disabled="sending"
                            :headers="uploadHeader"
                            :data="uploadData"
                            :action="uploadUrl"
                            accept=".xls,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            :with-credentials="true"
                            :show-file-list="false"
                            :on-progress="handleUploadProgress"
                            :on-success="handleUploadSuccess"
                            :on-error="handleUploadError"
                        >
                          <el-button
                              type="primary"
                              :disabled="sending"
                              :loading="sending"
                          >开始导入</el-button>
                        </el-upload>

                        <!-- <div class="cancel-link" @click="dialogVisiable = false">取消</div> -->
                    </div>
                </div>

                <el-divider></el-divider>

                <div class="import-tips">
                    注意事项：<br>
                    <!-- 1，开始导入前请先选择要导入的设备类型；<br> -->
                    1，模块中的表头名称不可修改，表头行不能删除；<br>
                    2，第一行内容为示例，可以修改或删除；<br>
                    3，支持文件格式：.xls
                </div>
            </div>

            <div class="import-box import-step2" v-show="stepsActive === 1">
                <div class="progress-status">正在导入…</div>

                <div class="progress">
                    <div class="progress-bar" :style="{width: importProgress + '%'}"></div>
                    <div class="progress-num">{{ importProgress }}%</div>
                    <div class="progress-tips" v-if="importStatus === 2">
                        <i class="el-icon-warning2"></i>
                        <span>{{ importMsg }}</span>
                    </div>
                </div>

                <div class="form-footer">
                    <el-button type="primary" @click="handleOpen">重新导入</el-button>
                    <div class="cancel-link" @click="dialogVisiable = false">取消</div>
                </div>

                <el-divider></el-divider>

                <div class="import-tips">
                    提示：导入数据较多时导入时间可能较长，请耐心等待。
                </div>
            </div>

            <div class="import-box import-step3" v-show="stepsActive === 2">
                <div class="progress-status">导入完成</div>

                <div class="progress">
                    <div class="progress-bar" :style="{width: importProgress + '%'}"></div>
                    <div class="progress-num">{{ importProgress }}%</div>
                    <div class="progress-tips">
                        <i class="el-icon-success"></i>
                        <span>{{ importMsg }}</span>
                    </div>
                </div>

                <div class="form-footer">
                    <el-button type="primary" @click="dialogVisiable = false">完成</el-button>
                    <div class="cancel-link" @click="handleOpen">继续导入</div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { ApiDeviceImport } from '@/api/device';
import { getToken } from '@/utils/auth';

export default {
  name: 'CDialogImport',
  data() {
    return {
      dialogVisiable: false,
      sending: false,
      stepsActive: 0,

      uploadUrl: ApiDeviceImport(),
      uploadHeader: {
          'Access-Token': getToken(),
      },
      uploadData: {
          sys_user_id: this.$store.getters.userId,
      },

      device_type: '',
      importProgress: 0,
      importStatus: 0, // 0 未开始 1 成功 2失败
      importMsg: '',
      intervalObj: null,
    };
  },
  // watch: {
  //   form: {
  //     handler(value) {
  //       let tmpPass = true;

  //       Object.keys(value).forEach((key) => {
  //         if (value[key] === '') {
  //           tmpPass = false;
  //         }
  //       });

  //       this.isFormSubmit = tmpPass;
  //     },
  //     deep: true,
  //   },
  // },
  created() {},
  mounted() {},
  methods: {
    // 弹出框初始化
    handleOpen() {
      this.dialogVisiable = true;

      this.$nextTick(() => {
          this.handleReset();
      });
    },

    // 重置数据
    handleReset() {
        clearInterval(this.intervalObj);
        this.sending = false;
        this.device_type = '';
        this.stepsActive = 0;
        this.importProgress = 0;
        this.importStatus = 0;
        this.importMsg = '';
    },

    // 文件上传中
    handleUploadProgress() {
        this.handleToImport();
    },

    // 文件上传成功
    handleUploadSuccess(res) {
        // console.log(res);
        if (res.code !== 1) {
            // 导入失败
            this.importStatus = 2;
            this.importMsg = res.data || '导入失败！';
        } else {
            // 导入成功
            setTimeout(() => {
                this.stepsActive = 2;
                this.importStatus = 1;
                this.importProgress = 100;
                this.importMsg = res.data || '导入成功！';

                this.$parent.handleGetList();
            }, 1000);
        }
    },

    // 文件上传失败
    handleUploadError(err) {
        console.log(err);

        clearInterval(this.intervalObj);
        
        this.importStatus = 2;
        this.importMsg = '导入失败！';
    },

    // 开始导入
    handleToImport() {
      if (this.sending) {
        return false;
      }

      this.sending = true;

      this.handleDataImport();
    },

    // 导入数据
    handleDataImport() {
      this.stepsActive = 1;

      this.intervalObj = setInterval(() => {
          if (this.importStatus !== 0) {
              clearInterval(this.intervalObj);
              return false;
          }

          if (this.importProgress >= 92) {
              clearInterval(this.intervalObj);
          } else {
            this.importProgress += 1;
          }
      }, 100);
    },

    // 关闭窗口
    handleDialogClose() {
        this.handleReset();
    },
  },
};
</script>


<style lang="scss" scoped>
.form-title {
    padding-left: 19px;
    padding-top: 6px;
}

.upload-botton {
    display: inline-block;
}
</style>
